module.exports = "https://r.nearpod.com/assets/media/image/close-icon-d076ec08a9eed57a0ae247bf16d4ded1.svg";